/* NP カート補助 v6（2026-10-05）株式会社ニューポート
   Liquid（snippets/np-cart-perks.liquid）の指示に従ってカートを整える：
   - data-np-remove：外す行（期間後・対象外の特典行、直リンクで入った ¥0 のトライアル・サンプル）
   - data-np-add：入れる特典（バリアントID:キー）。_np_gift と _is_sample を付けて1点ずつ入れる
   - data-np-one：数量を1に戻す特典行
   あわせて、トライアル・サンプルの商品ページに説明文を出し、購入ボタン類を隠す（np-gwp-tiers.css） */
(function () {
  var working = false;
  function reload() { location.reload(); }
  function list(el, name) { return el ? (el.getAttribute(name) || '').split(',').filter(Boolean) : []; }

  var LOOP_KEY = 'np_perks_fix';
  function guard() {
    // 万一の読み込み直しの繰り返しを防ぐ（30秒で3回まで）
    var n = 0, now = Date.now();
    try { var o = JSON.parse(sessionStorage.getItem(LOOP_KEY) || '{}'); n = (now - (o.t || 0) < 30000) ? (o.n || 0) : 0; sessionStorage.setItem(LOOP_KEY, JSON.stringify({ t: now, n: n + 1 })); } catch (e) {}
    return n < 3;
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }

  function fixIfNeeded() {
    if (working) return;
    var el = document.querySelector('[data-np-remove],[data-np-add],[data-np-one]');
    var rm = list(el, 'data-np-remove'), add = list(el, 'data-np-add'), one = list(el, 'data-np-one');
    if (!rm.length && !add.length && !one.length) return;
    if (!guard()) return;
    working = true;
    var updates = {};
    rm.forEach(function (k) { updates[k] = 0; });
    one.forEach(function (k) { if (!(k in updates)) updates[k] = 1; });
    var step = Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : Promise.resolve();
    step.then(function () {
      if (!add.length) return;
      var items = add.map(function (a) {
        var p = a.split(':');
        return { id: Number(p[0]), quantity: 1, properties: { _np_gift: p[1], _is_sample: 'true' } };
      });
      return post('/cart/add.js', { items: items });
    }).then(reload, reload);
  }

  /* トライアル・サンプルの商品ページ：説明文を価格の下に出す */
  function samplePdp() {
    if (!/\/products\//.test(location.pathname)) return;
    fetch(location.pathname.split('?')[0].replace(/\/$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || String(p.type) !== 'sample') return;
        document.documentElement.classList.add('np-sample-pdp');
        if (document.querySelector('.np-sample-note')) return;
        var n = document.createElement('div');
        n.className = 'np-sample-note';
        n.innerHTML = (p.description && /\S/.test(p.description.replace(/<[^>]+>/g, ''))) ? p.description
          : '<p>こちらはトライアルサイズです。単品ではご購入いただけません。</p>';
        var price = document.querySelector('.product-details product-price') || document.querySelector('product-price');
        if (price) price.insertAdjacentElement('afterend', n);
      }).catch(function () {});
  }

  var pending = false;
  new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; fixIfNeeded(); }, 300); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-np-remove', 'data-np-add', 'data-np-one'] });
  function boot() { samplePdp(); fixIfNeeded(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
